export interface StorageFile {
    storageFileId: string;
    originalFileName: string;
    name: string;
    bucket: string;
    downloadURL: string;
    fullPath: string;
    contentType: string;
}

export const StorageFileFormDefault = {
    bucket: "",
    downloadURL: "",
    name: "",
    originalFileName: "",
    storageFileId: "",
    contentType: "",
    fullPath: "",
};

export const isImage = (file?: StorageFile): boolean => {
    if (!file || !file.contentType) return false;
    return file.contentType.startsWith("image/");
};
